var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

//import includes from "core-js/library/fn/array/includes";

import * as types from "../utils/types";

import UnsupportedField from "./UnsupportedField";
import ArrayFieldNormal from "./ArrayFieldNormal";
import ArrayFieldFixed from "./ArrayFieldFixed";
import ArrayFieldFiles from "./ArrayFieldFiles";
import ArrayFieldSelect from "./ArrayFieldSelect";

import { getWidget, getDefaultFormState, isMultiSelect, isFilesArray, isFixedItems, allowAdditionalItems, optionsList, retrieveSchema, toIdSchema, getDefaultRegistry } from "../utils/";

var ArrayField = (_temp2 = _class = function (_Component) {
    _inherits(ArrayField, _Component);

    function ArrayField() {
        var _temp, _this, _ret;

        _classCallCheck(this, ArrayField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.canAddItem = function (formItems) {
            var _this$props = _this.props,
                schema = _this$props.schema,
                uiSchema = _this$props.uiSchema,
                uiOptions = _this$props.uiOptions;
            var addable = uiOptions.addable;


            if (addable !== false) {
                // if ui:options.addable was not explicitly set to false, we can add
                // another item if we have not exceeded maxItems yet
                if (schema.maxItems !== undefined) {
                    addable = formItems.length < schema.maxItems;
                } else {
                    addable = true;
                }
            }

            return addable;
        }, _this.onAddItem = function (item) {
            console.log('array:onAddItem', item);

            var _this$props2 = _this.props,
                schema = _this$props2.schema,
                formData = _this$props2.formData,
                registry = _this$props2.registry;
            var definitions = registry.definitions;

            var itemSchema = schema.items;

            if (isFixedItems(schema) && allowAdditionalItems(schema)) {
                itemSchema = schema.additionalItems;
            }

            _this.onChange([].concat(formData, [getDefaultFormState(itemSchema, item, definitions)]));
        }, _this.onChange = function (formData) {
            console.log('array:onChange', formData);

            if (_this.props.onChange) {
                _this.props.onChange(formData);
            }

            var id = _this.props.id;
            var formContext = _this.props.registry.formContext;


            setTimeout(function () {
                _this.onDialogChange();
            });
        }, _this.onDialogChange = function () {
            var _this$props3 = _this.props,
                id = _this$props3.id,
                schema = _this$props3.schema,
                formData = _this$props3.formData;
            var formContext = _this.props.registry.formContext;


            console.log('array:onDialogChange', id);

            if (formContext.dialog && formContext.onDialog && formContext.dialog.id && formContext.dialog.id === id) {

                formContext.onDialogChange(formData);

                /*
                formContext.onDialog({
                ...formContext.dialog,
                formData: formData
                })
                */
            }
        }, _this.onChangeIndex = function (index, value, errorSchema) {
            var _extends2;

            var formData = _this.props.formData;


            console.log('onChangeIndex', index);
            console.log('value', value);

            var newFormData = formData.map(function (item, i) {
                // We need to treat undefined items as nulls to have validation.
                // See https://github.com/tdegrunt/jsonschema/issues/206
                var jsonValue = typeof value === "undefined" ? null : value;
                return index === i ? jsonValue : item;
            });

            _this.onChange(newFormData, errorSchema && _this.props.errorSchema && _extends({}, _this.props.errorSchema, (_extends2 = {}, _extends2[index] = errorSchema, _extends2)));
        }, _this.onInsertAtIndex = function (item, index) {
            console.log('array:onInsertAtIndex', index);

            var _this$props4 = _this.props,
                schema = _this$props4.schema,
                formData = _this$props4.formData,
                registry = _this$props4.registry,
                canAdd = _this$props4.canAdd;
            var definitions = registry.definitions;


            var itemSchema = schema.items;

            if (isFixedItems(schema) && allowAdditionalItems(schema)) {
                itemSchema = schema.additionalItems;
            }

            var beforeIndex = formData.slice(0, index);
            var afterIndex = formData.slice(index);

            console.log('beforeIndex', beforeIndex);
            console.log('afterIndex', afterIndex);

            var newFormData = [].concat(beforeIndex, getDefaultFormState(itemSchema, item, definitions), afterIndex);

            console.log('newFormData', newFormData);

            if (newFormData) {
                _this.onChange(newFormData);
            }
        }, _this.onReorderIndex = function (index, newIndex) {
            console.log('array:onReorderIndex', index);

            var formData = _this.props.formData;

            // errorSchema

            var newErrorSchema = void 0;

            if (_this.props.errorSchema) {
                newErrorSchema = {};
                var errorSchema = _this.props.errorSchema;
                for (var i in errorSchema) {
                    if (i == index) {
                        newErrorSchema[newIndex] = errorSchema[index];
                    } else if (i == newIndex) {
                        newErrorSchema[index] = errorSchema[newIndex];
                    } else {
                        newErrorSchema[i] = errorSchema[i];
                    }
                }
            }

            // Copy item
            var newFormData = formData.slice();

            // Moves item from index to newIndex
            newFormData.splice(index, 1);
            newFormData.splice(newIndex, 0, formData[index]);

            // Array on Change
            _this.onChange(newFormData, newErrorSchema);
        }, _this.onRemoveIndex = function (index) {
            console.log('array:onRemoveIndex', index);

            var formData = _this.props.formData;
            // refs #195: revalidate to ensure properly reindexing errors

            var newErrorSchema = void 0;
            if (_this.props.errorSchema) {
                newErrorSchema = {};
                var errorSchema = _this.props.errorSchema;
                for (var i in errorSchema) {
                    i = parseInt(i);
                    if (i < index) {
                        newErrorSchema[i] = errorSchema[i];
                    } else if (i > index) {
                        newErrorSchema[i - 1] = errorSchema[i];
                    }
                }
            }
            _this.onChange(formData.filter(function (_, i) {
                return i !== index;
            }), newErrorSchema);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ArrayField.prototype.renderFixedArray = function renderFixedArray() {
        var _props = this.props,
            schema = _props.schema,
            uiSchema = _props.uiSchema,
            formData = _props.formData,
            registry = _props.registry;
        var definitions = registry.definitions;

        // items

        var items = this.props.formData;

        var itemSchemas = schema.items.map(function (item, index) {
            return retrieveSchema(item, definitions, formData[index]);
        });

        var additionalSchema = allowAdditionalItems(schema) ? retrieveSchema(schema.additionalItems, definitions, formData) : null;

        if (!items || items.length < itemSchemas.length) {
            // to make sure at least all fixed items are generated
            items = items || [];
            items = items.concat(new Array(itemSchemas.length - items.length));
        }

        var canAdd = this.canAddItem(items) && additionalSchema;

        return React.createElement(ArrayFieldFixed, _extends({}, this.props, { itemSchemas: itemSchemas, items: items, canAdd: canAdd,
            onChangeIndex: this.onChangeIndex,
            onReorderIndex: this.onReorderIndex,
            onInsertAtIndex: this.onInsertAtIndex,
            onRemoveIndex: this.onRemoveIndex }));
    };

    ArrayField.prototype.renderNormalArray = function renderNormalArray() {
        var _props2 = this.props,
            formData = _props2.formData,
            uiSchema = _props2.uiSchema;


        var items = formData;
        var canAdd = this.canAddItem(formData);

        return React.createElement(ArrayFieldNormal, _extends({}, this.props, { items: items, canAdd: canAdd,
            onChangeIndex: this.onChangeIndex,
            onReorderIndex: this.onReorderIndex,
            onInsertAtIndex: this.onInsertAtIndex,
            onRemoveIndex: this.onRemoveIndex }));
    };

    ArrayField.prototype.render = function render() {
        var _props3 = this.props,
            schema = _props3.schema,
            uiSchema = _props3.uiSchema,
            idSchema = _props3.idSchema,
            registry = _props3.registry;
        var definitions = registry.definitions;


        if (!schema.hasOwnProperty("items")) {
            return React.createElement(UnsupportedField, {
                schema: schema,
                idSchema: idSchema,
                reason: "Missing items definition"
            });
        }

        if (isFilesArray(schema, uiSchema, definitions)) {

            return React.createElement(ArrayFieldFiles, this.props);
        }

        if (isMultiSelect(schema, definitions)) {

            return React.createElement(ArrayFieldSelect, this.props);
        }

        if (isFixedItems(schema)) {
            return this.renderFixedArray();
        }

        return this.renderNormalArray();
    };

    return ArrayField;
}(Component), _class.defaultProps = {
    uiSchema: {},
    formData: [],
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
}, _temp2);
ArrayField.propTypes = process.env.NODE_ENV !== "production" ? types.fieldProps : {};


export default ArrayField;